import React from 'react'
import { graphql } from 'gatsby'

import ResponsiveContainer from 'components/utils/ResponsiveContainer'

const Intro = ({ logo, dateString, text}) => {
    return (
        <section>
            <ResponsiveContainer className="pt-16 pb-16">
                <div className="md:flex md:items-center">
                    <div className="mb-12 md:w-1/2 md:order-2 md:mb-0 md:pl-8">
                        <img src={ logo } className="w-96 max-w-full " />
                    </div>
                    <div className="grid grid-flow-row gap-12 md:w-1/2 md:order-1 md:pr-12">
                        <p className="text-2xl font-bold uppercase">{ dateString }</p>
                        { text }
                    </div>
                </div>
            </ResponsiveContainer>
        </section>
    )
}

export default Intro
